import React, { Component } from 'react';
import { connect } from 'react-redux';
import history from '../../../history';
import actions from '../../../actions';
import UnallocatedFreelancersTable from './table';
import { withRefreshTableOnFilterChange } from '../common/decorators';
import { TDispatch } from '../../../reducers';
import { TFreelancerData, TMeta, TPageNotification, TUser } from '../../../types';

type TUnallocatedFreelancersProps = {
    load: (searchParams: URLSearchParams, isInitialLoad?: boolean) => void;
    content: TFreelancerData[];
    meta: TMeta;
    error: string;
    fetching: boolean;
    notification: TPageNotification;
    user: TUser;
    selectedUnallocatedFreelancers: TFreelancerData[];
    setSelectedUnallocatedFreelancers: (allSelectedFreelancers: TFreelancerData[]) => void;
}

type TUnallocatedFreelancersState = {
    unallocatedFreelancers: TFreelancerData[];
    user: TUser;
}


const MIN_SEARCH_LEN = 3;

// @ts-ignore
@withRefreshTableOnFilterChange
class UnallocatedFreelancers extends Component<TUnallocatedFreelancersProps, TUnallocatedFreelancersState> {
    componentDidMount() {
        const currentUrlParams = new URLSearchParams(history.location.search);
        // second parameter is needed to trigger isInitialLoad
        this.props.load(currentUrlParams, true);
    }

    componentDidUpdate(prevProps: Readonly<TUnallocatedFreelancersProps>) {
        if (this.props.error && prevProps.error !== this.props.error) {
            this.props.notification.error('Error', this.props.error);
        }
    }

    render() {
        const currentUrlParams = new URLSearchParams(history.location.search);
        let pages = -1;
        let showPaginationBottom = false;

        if (this.props.content && this.props.meta) {
            pages = Math.ceil(this.props.meta.count / 20);
            showPaginationBottom = this.props.meta.count > 20;
        }

        return (
            <UnallocatedFreelancersTable
                data={this.props.content}
                pages={pages}
                showPaginationBottom={showPaginationBottom}
                loading={this.props.fetching}
                notification={this.props.notification}
                user={this.props.user}
                meta={this.props.meta}
                reloadData={() => this.props.load(currentUrlParams)}
                selectedUnallocatedFreelancers={this.props.selectedUnallocatedFreelancers}
                setSelectedUnallocatedFreelancers={this.props.setSelectedUnallocatedFreelancers}
                currentUrlParams={currentUrlParams}
            />
        );
    }
}

const mapStateToProps = (state: TUnallocatedFreelancersState) => ({
    ...state.unallocatedFreelancers,
    user: state.user,
});

const mapDispatchToProps = (dispatch: TDispatch) => ({
    load: (searchParams: URLSearchParams, isInitialLoad = false) => {
        const searchValue = searchParams.get('search');
        if (isInitialLoad || !searchValue || searchValue.length >= MIN_SEARCH_LEN) {
            dispatch(actions.loadUnallocatedFreelancers(searchParams));
        }
    },
    setSelectedUnallocatedFreelancers: (items: TFreelancerData[]) =>
        dispatch(actions.setSelectedUnallocatedFreelancers(items)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UnallocatedFreelancers);
